<template>
    <div v-show="show" class="resourcesDetail-container">
        <div class="resourcesDetailContent">
            <div class="top">
                <div class="title">{{detail.task_title || title}}</div>
                <p>
                    仅保存近{{days}}天记录
                </p>
            </div>
            <div class="info">
                <div class="item">
                    <p>实用类</p>
                    <span>{{detail.relate_type}}</span>
                </div>
                <div class="item">
                    <p>使用人</p>
                    <span>{{detail.username}}</span>
                </div>
            </div>
            <div class="info">
                <div class="item">
                    <p>可使用时间</p>
                    <span>{{detail.start}}  ~   {{detail.end}}</span>
                </div>
                <div class="item">
                    <p>归还确认时间</p>
                    <span>{{detail.return_time}}</span>
                </div>
            </div>
            <div class="line">
                <div>
                    使用操作记录
                </div>
            </div>
            <div :class="{titleline: true, record: true}">
                <span class="date">时间</span>
                <span class="handles">操作</span>
                <span class="user">操作人</span>
                <span class="content">操作结果/内容</span>
            </div>
            <empty style="height: 320px" :mTop="50" :msg="'暂无数据'" v-if="log && log.length === 0" />
            <div v-if="log && log.length > 0" class="itemsList">
                <div class="items" v-for="resource in log" :key="resource.title">
                    <div :class="{item: true, record: true}">
                        <div class="date">
                            {{resource.time}}
                        </div>
                        <div class="handles">
                            {{resource.type_name}}
                        </div>
                        <div class="user">
                            {{resource.username}}
                        </div>
                        <div class="content">
                            <div class="word">
                                <p v-if="resource.type == 3">延期时间：<span>{{resource.delay_time}}</span></p>
                                <p v-if="resource.type == 3 && resource.remark">理由：{{resource.remark}}</p>
                                <p v-if="resource.type == 4">结果：<span :class="{r: resource.color == 'red',g: resource.color == 'green'}">{{resource.result_name}}</span></p>
                                <p v-if="resource.type == 4 && resource.color == 'red' && resource.remark">理由：{{resource.remark}}</p>
                                <p v-if="resource.type == 5">结果：<span :class="{r: resource.color == 'red',g: resource.color == 'green'}">{{resource.result_name}}</span></p>
                                <p v-if="resource.type == 5 && resource.color == 'red' && resource.remark">理由：{{resource.remark}}</p>
                                <p v-if="resource.type == 6">留言：{{resource.remark || '无'}}</p>
                                <p v-if="resource.type == 7"><span :class="{r: resource.color == 'red',g: resource.color == 'green'}">{{resource.result_name}}</span></p>
                                <p v-if="resource.type == 7 && resource.color == 'green' && resource.remark">设备检查：{{resource.remark}}</p>
                                <p v-if="resource.type == 7 && resource.color == 'red' && resource.remark">理由：{{resource.remark}}</p>
                            </div>
                            <img v-if="resource.img_url" :src="resource.img_url" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div @click="close" class="confirm">确认</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
export default {
    components: {
        empty
    },
    watch: {
        value1(to) {
            console.log(to)
        }
    },
    data() {
        return {
            days: '',
            resources: [],
            show: false,
            config: {},
            callback: null,
            title: '操作记录',
            value1: '',
            detail: {},
            log: []
        }
    },
    methods: {
        open(config, callback) {
            let body = document.getElementsByTagName('body')[0]
            body.style.position = 'fixed'
            console.log(body)
            this.config = config;
            if(config){
                this.getDetail()
            }
            this.callback = callback;
            this.show = true;
        },
        getDetail() {
            let info = {
                task_id: this.config
            }
            
            common.myFetch(apis.Task_log, info).then(res => {
                this.days = res.days
                this.detail = res.detail
                this.log = res.log
                console.log(res)
            })
        },
        confirm() {
            
        },
        cancel() {
            let body = document.getElementsByTagName('body')[0]
            body.style.position = 'unset'
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>
<style src="./assets/index.less" lang="less" scoped>

</style>
<style lang="less">
.el-button--text {
    color: #41B48C !important;

    &:hover {
        color: #41B48C !important;
    }
}

.el-button.is-plain:focus, .el-button.is-plain:hover {
    color: #41B48C !important;
    border-color: #41B48C !important;
}
</style>